import { getDataSource } from '@rsos/components/capstone/Location/helpers';
import { Box, Text } from '@rsos/components/capstone/base';
import type { EmergencyCallLocation } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';
import getCallStatusName from '@rsos/utils/getCallStatusName';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';
import {
  CallStatus,
  CallStatusTag,
} from '../../../../Queue/EmergencyCall/EmergencyCall.styles';

interface PopupData {
  callData: EmergencyCallLocation;
  callStatus: string;
}

interface CallPopupProps {
  isAllView?: boolean;
  popupData: PopupData;
}

/**
 * Component for rendering call data in a popup. Currently only used for Esri.
 */
const CallPopup = ({ isAllView, popupData }: CallPopupProps) => {
  const callerID = popupData.callData.caller_id;

  const formattedCallerID = formatInternationalPhoneNumberHuman(callerID);
  const source = getDataSource(popupData.callData);
  const callStatus = popupData.callStatus;
  const callStatusDisplayName = getCallStatusName(callStatus);
  const startTime = Number(
    popupData.callData.location_time || popupData.callData.call_start_time,
  );

  return (
    <Box>
      <Text marginBottom="5px" size="large" fontWeight="bold">
        {formattedCallerID}
      </Text>
      <Text marginBottom="5px" size="large">
        {convertUnixTimestamp(startTime, true)}
      </Text>
      {callStatusDisplayName && (
        <CallStatusTag status={callStatus} isCallPopup={true}>
          <CallStatus data-name="call-status" status={callStatus}>
            {callStatusDisplayName}
          </CallStatus>
        </CallStatusTag>
      )}
      {!isAllView && <Text size="small">Source: {source}</Text>}
    </Box>
  );
};

export default CallPopup;
